import { Api } from "@/core/services/api.service";
import { OrganizationRootDetailApi } from "@/apps/shared/organization/core/infrastructure/repository/OrganizationRootDetailApi";
import { Account } from "@/apps/shared/organization/core/domain/Account";

class WebtokenWithAccountAndOrdRepository {
  async getWebtokenWithAccountAndOrd(organizationURL: string): Promise<{
    token: string;
    ord: OrganizationRootDetailApi;
    account: Account;
  }> {
    const formData = new FormData();
    formData.append("url", organizationURL);
    const response = await Api.newAuthentication().post("/webtoken-with-account-and-ord", formData);

    const { token, ord, account }: { token: string; ord: OrganizationRootDetailApi; account: Account } = response.data;

    return {
      token,
      ord,
      account,
    };
  }
}

export default new WebtokenWithAccountAndOrdRepository();
